type Routes = {
  key: string
  name: string
  location: string
  relativePath?: string
}[]
type Route = Routes[number]
export type RouteKeyType = Route['key']
export type RouteLocationType = Route['location']
export type RouteOptionsType = {
  exact?: boolean
}

export const definition = [
  // DEV TOOLS
  {
    key: 'devTools',
    name: 'Developer tools',
    location: '/project/:projectId/devTools',
  },
  // SYSTEM
  {
    key: 'unauthorized',
    name: 'Unauthorized',
    location: '/unauthorized',
  },
  {
    key: 'notFound',
    name: 'Not Found',
    location: '/not-found',
  },
  // PROJECT
  {
    key: 'projectDashboard',
    name: 'dashboard',
    location: '/',
  },
  {
    key: 'projectGeneral',
    name: 'Project general',
    location: '/project/*',
  },
  {
    key: 'contentDetail',
    name: 'Content detail',
    location: '/project/:projectId/content/:contentId/path/:pathId',
  },
  // LIVE EDITORS
  {
    key: 'liveEditorContent',
    name: 'Content live editor',
    location: '/project/:projectId/path/:pathId/content/:contentId/live-editor',
  },
  {
    key: 'liveEditorReusableBlock',
    name: 'Reusable block live editor',
    location:
      '/project/:projectId/path/:pathId/content/:contentId/reusable-block/:reusableContentBlockId/live-editor',
  },
  // TEMPLATES
  {
    key: 'projectTemplates',
    name: 'Templates',
    location: '/project/:projectId/templates/list',
  },
  {
    key: 'playground',
    name: 'Playground',
    location: '/playground',
  },
] as Routes

function searchBy<K extends keyof Route>(key: K, value: Route[K]) {
  // const result = search(definition, `[?${key}=='${value}'] | [0]`)
  const result = definition.find((item) => item[key] === value)

  if (!result) {
    throw Error(
      `Route definition be condition "${key}" = "${value}" not found!`,
    )
  }

  return result
}

export function getRouteByKey<K extends RouteKeyType>(key: K) {
  return searchBy('key', key)
}

export function getRouteLocationByKey(key: RouteKeyType) {
  const route = searchBy('key', key)
  return route.relativePath || route.location
}

export function getRouteByLocation(location: RouteLocationType) {
  return searchBy('location', location)
}
